<template>
  <div class="pca-plot-sidebar">
    <BackButton :clickMethod="back" class="mb-3"/>
    <h4>
      {{$tI('Advanced reports')}} | <br/>
      {{$tI('Genetic Distance Maps Title')}}
      <span @click="pcaPlotInfoModal.showModal = true" class="open-info-modal-btn"
        v-click-track="'Iframe.ancientDnaGeneticDistanceMapsReportTooltipClicked'">
        <InfoIcon />
      </span>
    </h4>

    <p class="description mt-2" v-html="$tI_G('Genetic Distance Maps Subtitle')">
    </p>
    <PcaPlotsRegions />

    <div class="d-flex align-items-center mt-4">
      <span class="lab-switch-desc"> {{$tI_G('Show clusters toggle')}}</span> 
      <label class="lab-switch">
        <input type="checkbox" v-model="$store.state.pcaSourceData.isEnableConvexHull"
          v-click-track="'Iframe.ancientDnaGeneticDistanceMapsShowClustersToggleOn'">
        <span class="slider round"></span>
      </label>
    </div>

    <PcaPlotInfoModal v-if="pcaPlotInfoModal.showModal" :modalObject="pcaPlotInfoModal"/>
  </div>
</template>

<script>
import BackButton from '@/components/ui/BackButton.vue';
import InfoIcon from '@/components/icons/InfoIcon.vue';
import PcaPlotsRegions from './PcaPlotsRegions.vue';
import PcaPlotInfoModal from '../modals/PcaPlotInfoModal.vue';

export default {
  components: {
    BackButton,
    InfoIcon,
    PcaPlotsRegions,
    PcaPlotInfoModal
  },
  data() {
    return {
      pcaPlotInfoModal: {
        showModal: false,
      },
      regionDatas: [],
    };
  },
  methods: {
    back() {
      this.$router.push({ name: 'dashboard' });
    },
  },
  computed: {
  },
  mounted() {
    this.$store.dispatch('pcaRegion/fetchRegionDatas', this.$store.state.kit.default_ethnicity).then(() => {
      this.regionDatas = this.$store.getters['pcaRegion/getRegionDatas'];
    });
  }
};
</script>

<style lang="scss" scoped>
.pca-plot-sidebar {
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  padding: 28px;
  height: 100%;
  background-color: var(--white-100);
}

</style>